import * as yup from 'yup'

const defaultRequiredMessage = 'Este campo é obrigatório'

yup.setLocale({
  mixed: {
    required: defaultRequiredMessage
  }
})

export const validationSchema = (tutorWithoutEmail = false) => yup.object().shape({
  name: yup.string().trim().required(),
  email: !tutorWithoutEmail ? yup.string().trim().required() : undefined,
  document: yup.string().trim(),
  homePhone: yup.string().trim()
})
